// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "client-editor/" + ({"4905":"AboutEditComponent","7945":"AboutEditModal","8634":"RootWidget"}[chunkId] || chunkId) + ".chunk.min.css";
};